/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Insights_Lpprofile_Fundbreakdown_Empty3Inputs */

const en_coinvestments_insights_lpprofile_fundbreakdown_empty3 = /** @type {(inputs: Coinvestments_Insights_Lpprofile_Fundbreakdown_Empty3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No fund breakdown`)
};

/**
* | output |
* | --- |
* | "No fund breakdown" |
*
* @param {Coinvestments_Insights_Lpprofile_Fundbreakdown_Empty3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_insights_lpprofile_fundbreakdown_empty3 = /** @type {((inputs?: Coinvestments_Insights_Lpprofile_Fundbreakdown_Empty3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Insights_Lpprofile_Fundbreakdown_Empty3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_insights_lpprofile_fundbreakdown_empty3(inputs)
});
export { coinvestments_insights_lpprofile_fundbreakdown_empty3 as "coInvestments_insights_lpProfile_fundBreakdown_empty" }